<template>
	<div>
		<v-form-render v-if="checkShow" :form-json="formJson" :form-data="formData" :option-data="optionData"
			ref="vFormRef">
		</v-form-render>
		<div v-if="checkShow">
			<el-button @click="cacenclSubmit">取消</el-button>
			<el-button type="primary" @click="submitForm">提交</el-button>
		</div>

		<el-dialog title="报名成功" :visible.sync="dialogVisiblex" :width="successApply" :before-close="cacenclSubmit">
			<div class="cropper-content contentDetail" v-html="successInfo">

			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cacenclSubmit">确定</el-button>
				<!-- <el-button type="primary" @click="resetForm">提交并填写下一个</el-button> -->
			</div>
		</el-dialog>

		<el-dialog title="报名确认" :visible.sync="dialogVisible" :width="dialogWidth" :before-close="handleClose">
			<el-descriptions title="" direction="vertical" :column="columnNum" border>
				<el-descriptions-item v-for="(item ,index ) in preViewList" :key="index" :label="item.label">
					<img v-if="hasImage(item.value)" :src="item.value"
						style="width: 100%;height: 200px;object-fit: contain;" alt="">
					<p v-else>{{item.value}}</p>
				</el-descriptions-item>
			</el-descriptions>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submitApply">确 认 提 交</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		mapGetters
	} from 'vuex'
	import {
		getForm,
		setFormNoVip,
		getFormVip,
		setFormVip,
		vipSubmitCheck,
		noVipSubmitCheck
	} from '@/api/moudles/activities.js'

	export default {
		data() {
			return {
				columnNum: 4,
				successApply: '1000px',
				dialogWidth: '50%',
				dialogVisible: false,
				preViewList: [],
				successInfo: '',
				dialogVisiblex: false,
				rule_code: '',
				// 自定义表单相关
				checkShow: false,
				/* 注意：formJson是指表单设计器导出的json，此处演示的formJson只是一个空白表单json！！ */
				formJson: {
					"widgetList": [],
					"formConfig": {
						"labelWidth": 80,
						"labelPosition": "left",
						"size": "",
						"labelAlign": "label-left-align",
						"cssCode": "",
						"customClass": "",
						"functions": "",
						"layoutType": "PC",
						"onFormCreated": "",
						"onFormMounted": "",
						"onFormDataChange": ""
					}
				},
				formData: {

				},
				optionData: {}
			}
		},
		computed: {
			...mapGetters({
				userInfo: 'user/USERINFO',
			}),
			hasImage() {
				return (value) => {
					if (value && typeof value == 'string') {
						if (value.indexOf('http') != -1) {
							return true
						}
					}
					return false
				}
			}
		},
		mounted() {
			if (this.$phoneSize()) {
				this.dialogWidth = '99%'
				this.successApply = '99%'
				this.columnNum = 2
			} else {
				this.dialogWidth = '50%'
				this.successApply = '1000px'
				this.columnNum = 4
			}
		},
		methods: {
			submitApply() {
				this.dialogVisible = false
				if (this.$store.state.user.userVip === true) {
					this.setFormVip(this.formData)
				} else {
					this.setFormNoVip(this.formData)
				}
			},
			handleClose() {
				this.dialogVisible = false
			},
			// 启动组件
			startComp(rule_code) {
				this.rule_code = rule_code
				if (this.$store.state.user.userVip === true) {
					// 是会员
					this.getFormVip(rule_code)
				} else {
					// 非会员
					this.getForm(rule_code)
				}
			},
			// 重置提交下一个
			resetForm() {
				this.dialogVisiblex = false
				this.checkShow = false
				if (this.$store.state.user.userVip === true) {
					// 是会员
					this.getFormVip(this.rule_code)
				} else {
					// 非会员
					this.getForm(this.rule_code)
				}
			},
			//自定义表单提交
			submitForm() {
				this.$refs.vFormRef.getFormData().then(formData => {
					this.formData = formData
					if (this.$store.state.user.userVip === true) {
						vipSubmitCheck({
							data: {
								rule_code: this.rule_code,
								form: formData
							},
							success: res => {
								if (res.code != '200') {
									this.$alert(res.msg, '提示', {
										confirmButtonText: '关闭',
									});
								} else {
									if (res.data) {
										this.preViewList = res.data
									}
									this.dialogVisible = true
								}
							}
						})
					} else {
						noVipSubmitCheck({
							data: {
								rule_code: this.rule_code,
								form: formData
							},
							success: res => {
								if (res.code != '200') {
									this.$alert(res.msg, '提示', {
										confirmButtonText: '关闭',
									});
								} else {
									if (res.data) {
										this.preViewList = res.data
									}
									this.dialogVisible = true
								}
							}
						})
					}
				}).catch(error => {
					this.$message.error(error)
				})
			},
			// 非会员提交表单
			setFormNoVip(form) {
				setFormNoVip({
					data: {
						rule_code: this.rule_code,
						form
					},
					success: res => {
						// console.log('非会员提交表单', res)
						if (res.code == 200) {
							this.$message({
								message: res.msg,
								type: 'success'
							});
							this.dialogVisiblex = true
							this.successInfo = res.data
							this.formData = {}
						} else {
							this.$message.error(res.msg)
						}
					}
				})
			},
			// 会员提交表单
			setFormVip(form) {
				setFormVip({
					data: {
						rule_code: this.rule_code,
						form
					},
					success: res => {
						console.log('会员提交表单', res)
						if (res.code == 200) {
							this.$message({
								message: res.msg,
								type: 'success'
							});
							this.dialogVisiblex = true
							this.successInfo = res.data
							this.formData = {}
						} else {
							this.$message.error(res.msg)
						}
					}
				})
			},
			// 获取会员自定义表单
			getFormVip(rule_code) {
				if (this.userInfo) {
					let birth_date = this.userInfo.birth.split('')
					const date = birth_date.slice(0, 4).join('') + '-' + birth_date.slice(4, 6).join('') + '-' + birth_date
						.slice(6, 8).join('')
					this.formData = {
						birth: date,
						cellphone: this.userInfo.cellphone,
						company_name: this.userInfo.company_name,
						input26342: this.userInfo.real_name,
						input52879: this.userInfo.company_name,
						input81955: this.userInfo.cellphone,
						position: this.userInfo.position,
						real_name: this.userInfo.real_name,
						sex: this.userInfo.sex === '男' ? 1 : 2
					}
				}
				getFormVip({
					data: {
						rule_code
					},
					success: res => {
						if (res.code === 200) {
							if (res.data) {
								this.checkShow = true
								this.formJson = JSON.parse(res.data)
							}
						} else {
							this.$message.error(res.msg)
							setTimeout(() => {
								this.$emit('cancenclsubmit', true)
							}, 800)
						}
					}
				})
			},
			/* 获取非会员自定义表单 */
			getForm(rule_code) {
				this.formData = {
					cellphone: this.$store.state.user.noVipPhone,
					input81955: this.$store.state.user.noVipPhone,
				}
				getForm({
					data: {
						rule_code
					},
					success: res => {
						if (res.code === 200) {
							if (res.data) {
								this.checkShow = true
								this.formJson = JSON.parse(res.data)
							}
						} else {
							this.$message.error(res.msg)
							setTimeout(() => {
								this.$emit('cancenclsubmit', true)
							}, 800)
						}
					}
				})
			},
			// 取消
			cacenclSubmit() {
				this.dialogVisiblex = false
				this.checkShow = false
				this.$emit('cancenclsubmit', true)
			},
		}
	}
</script>

<style scoped>
	>>>.contentDetail img,
	.contentDetail p>img,
	.contentDetail span>img {
		max-width: 100%;
	}
</style>